import { apiClient } from "./client"

import type { LoginResponse, Professor } from "@/types"

export interface ChangePasswordPayload {
  current_password: string
  new_password: string
}

export const authApi = {
  login: (email: string, password: string) =>
    apiClient.post<LoginResponse>("/auth/login", { email, password }).then((r) => r.data),

  me: () => apiClient.get<Professor>("/auth/me").then((r) => r.data),

  updateMe: (data: Partial<Professor>) =>
    apiClient.patch<Professor>("/auth/me", data).then((r) => r.data),

  changePassword: (data: ChangePasswordPayload) =>
    apiClient.post<{ success: boolean }>("/auth/me/password", data).then((r) => r.data),
}
